import { render, staticRenderFns } from "./AppTypeActivity.vue?vue&type=template&id=4bb3667a"
import script from "./AppTypeActivity.vue?vue&type=script&lang=js"
export * from "./AppTypeActivity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports